import { getStoryblokImageUrl } from '@/lib/utils';
import Image from 'next/image';
import { FC } from 'react';

export interface ImageFeaturedProps {
  uid: any;
  image: any;
  size: any;
}

const ImageFeatured: FC<ImageFeaturedProps> = ({ uid, image, size }) => {
  let containerWidth: string;

  switch (size) {
    case 'full':
      containerWidth = '';
      break;
    case 'lg':
      containerWidth = 'max-w-7xl';
      break;
    case 'sm':
      containerWidth = 'max-w-5xl';
      break;
    default:
      containerWidth = '';
      break;
  }

  if (!image?.filename) return null;

  return (
    <div key={uid} className={`mx-auto ${containerWidth}`}>
      <div className="not-prose relative py-6 md:py-8 lg:py-12">
        <Image
          alt={image?.alt}
          src={getStoryblokImageUrl(image?.filename, 1024, 0)}
          width={1024}
          height={0}
          className="w-full"
        />
      </div>
    </div>
  );
};

export default ImageFeatured;
